import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as dates from '@simplybenefits/sb-dates';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import Text from '../../components/Text.js';
import Content from '../../components/Content.js';
import DateInput from '../../components/TextFields/DateInput.js';
import { validateInput, massUpdateTypes } from '../../services/index.js';
import Modal from './Modal.js';
import MassUpdateDropZoneModal from './MassUpdateDropZoneModal.js';

/**
 *
 * @param dispatch
 * @param close
 * @param loader
 * @param type
 * @param upload
 * @param download
 * @returns {JSX.Element}
 * @constructor
 */
const MassUpdate = ({
  dispatch,
  close,
  loader,
  type,
  upload,
  download
}) => {
  const styles = {
    list: {
      listStyleType: 'decimal'
    }
  };
  const modalStates = ['Template', 'FileUpload', 'EffectiveDate'];
  const [selectedType, setSelectedType] = useState(null);
  const [modalState, setModalState] = useState(modalStates[0]);
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState(null);
  const [effectiveDate, setEffectiveDate] = useState(null);
  const [effectiveDateError, setEffectiveDateError] = useState(null);
  useEffect(() => {
    setSelectedType(massUpdateTypes[type]);
  }, []);

  /**
   * Download Template
   */
  const downloadTemplate = () => {
    download(selectedType);
  };

  /**
   *
   * @param files
   */
  const uploadFile = files => {
    setModalState(modalStates[2]);
    setFile(files[0]);
  };

  /**
   *
   * @returns {Promise<void>}
   */
  const submit = async () => {
    const effDateError = validateInput('effectiveDate', effectiveDate, i18n.locale);
    setEffectiveDateError(effDateError);
    const form = new FormData();
    form.append('file', file);
    form.append('type', type);
    form.append('effectiveDate', dates.getUTC(effectiveDate));
    const result = await dispatch(upload(form));
    if (result && 'errors' in result) {
      setModalState(modalStates[1]);
      setFile(null);
      setEffectiveDate(null);
      setErrors(result.errors);
    }
    if (result.isSuccessful) {
      close();
    }
  };
  return /*#__PURE__*/React.createElement(Content, null, modalState === modalStates[0] ? /*#__PURE__*/React.createElement(Modal, {
    open: true,
    onClose: close,
    title: i18n.t(tokens.labels.massUpdate.massUpdateTitle),
    primaryButton: {
      label: i18n.t(tokens.labels.massUpdate.uploadChanges),
      onClick: () => {
        setFile(null);
        setModalState(modalStates[1]);
      }
    },
    secondaryButton: {
      label: i18n.t(tokens.labels.massUpdate.downloadTemplate),
      onClick: () => downloadTemplate()
    },
    loader: loader
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    light: true
  }, "Please follow the instructions below to complete a mass update."), /*#__PURE__*/React.createElement("ul", {
    style: styles.list
  }, /*#__PURE__*/React.createElement("li", null, i18n.t(tokens.labels.massUpdate.step1)), /*#__PURE__*/React.createElement("li", null, i18n.t(tokens.labels.massUpdate.step2)), /*#__PURE__*/React.createElement("li", null, i18n.t(tokens.labels.massUpdate.step3)), /*#__PURE__*/React.createElement("li", null, i18n.t(tokens.labels.massUpdate.step4)), /*#__PURE__*/React.createElement("li", null, i18n.t(tokens.labels.massUpdate.step5)), /*#__PURE__*/React.createElement("li", null, i18n.t(tokens.labels.massUpdate.step6)))) : null, modalState === modalStates[1] ? /*#__PURE__*/React.createElement(MassUpdateDropZoneModal, {
    onBack: () => setModalState(modalStates[0]),
    subText: i18n.t(tokens.labels.massUpdate.uploadCSV),
    title: i18n.t(tokens.labels.massUpdate.massUpdateTitle),
    errors: errors,
    fieldNames: selectedType.fieldNames,
    hideModal: close,
    showModal: true,
    maxItems: 1,
    submitFile: uploadFile,
    skipClose: true,
    acceptedFiles: "text/csv, .csv"
  }) : null, modalState === modalStates[2] ? /*#__PURE__*/React.createElement(Modal, {
    open: true,
    onClose: close,
    onBack: () => {
      setFile(null);
      setEffectiveDateError(null);
      setEffectiveDate(null);
      setModalState(modalStates[1]);
    },
    title: i18n.t(tokens.labels.massUpdate.massUpdateTitle),
    primaryButton: {
      label: i18n.t(tokens.labels.massUpdate.submit),
      onClick: submit
    },
    loader: loader
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    light: true
  }, i18n.t(tokens.labels.massUpdate.provideDateToBeEffective)), /*#__PURE__*/React.createElement(DateInput, {
    label: i18n.t(tokens.labels.massUpdate.effectiveDate),
    value: effectiveDate,
    onChange: e => setEffectiveDate(e.target.value),
    error: Boolean(effectiveDateError),
    helperText: effectiveDateError,
    fullWidth: true,
    required: true
  })) : null);
};

/**
 *
 * @param state
 * @returns {{loader}}
 */
const mapStateToProps = state => ({
  loader: state.loader
});
export default connect(mapStateToProps)(MassUpdate);